<template>
  <div>
    <v-row dense>
      <v-col cols="4">
        <v-checkbox
          v-model="form.receive_via_email"
          name="receive_via_email"
          :readonly="readonly"
          :label="$t('PROFILE.RECEIVE_INVOICES_VIE_EMAIL')"
          :error-messages="errors.receive_via_email"
          @change="updateValue('receive_via_email', $event)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="form.invoice_email"
          name="invoice_email"
          :readonly="readonly"
          :label="$t('PROFILE.EMAIL_FOR_INVOICES')"
          :rules="getRulesByName('invoice_email')"
          :error-messages="errors.invoice_email"
          @input="updateValue('invoice_email', $event)"
        />
      </v-col>
    </v-row>
    <v-row dense class="mt-0">
      <v-col cols="4">
        <v-checkbox
          v-model="form.without_vat"
          name="without_vat"
          :readonly="readonly"
          :label="$t('EREPORTER.INVOICES.WITHOUT_VAT')"
          :rules="getRulesByName('without_vat')"
          :error-messages="errors.without_vat"
          @change="updateValue('without_vat', $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { email, requiredEmail } from '@/modules/_global/variables/rules';

export default {
  name: 'BillingForm',

  mixins: [formEditable],

  data() {
    return {
      form: {
        personal_profile: {
          receive_via_email: false,
          invoice_email: '',
          without_vat: false
        }
      }
    };
  },

  computed: {
    rules() {
      return {
        invoice_email: this.form.receive_via_email ? requiredEmail : email
      };
    }
  }
};
</script>

<style scoped></style>
